import { ComponentType } from '../schematics/components/components-generator';

// add selected elements to this array, then values are available in other schematics
export const selectedElements: ComponentType[] = [];
